import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

import TodoItem from '@/components/optypes/frontend/SimpleChecklist/components/Item'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)
  const [getUserContents, setUserContents] = useAtom(userContents)

  let borderWidth = returnBlockValue(
    'borderwidth',
    'design',
    opBlocks[block],
    design
  )
  let borderVisible = returnBlockValue(
    'bordervisible',
    'design',
    opBlocks[block],
    design
  )

  if (borderVisible === 'false') {
    borderWidth = 0
  }

  return (
    <div
      className={Classnames(
        'mx-auto opr-card opr-cardchecklist bg-white p-12 rounded-lg border',
        returnBlockValue('dropshadow', 'design', opBlocks[block], design)
      )}
      style={{
        backgroundColor: returnBlockValue(
          'background',
          'design',
          opBlocks[block],
          design
        ),
        color: returnBlockValue('textcolor', 'design', opBlocks[block], design),
        borderColor: returnBlockValue(
          'bordercolor',
          'design',
          opBlocks[block],
          design
        ),
        marginBottom: `${returnBlockValue(
          'marginbottom',
          'design',
          opBlocks[block],
          design
        )}px`,
        borderWidth: `${borderWidth}px`,
        maxWidth: '600px',
      }}
    >
      <h2 className="text-4xl font-bold mb-2">
        {returnBlockValue('headline', 'content', opBlocks[block], content)}
      </h2>

      <h4 className="text-lg opacity-85 font-medium mb-4">
        {returnBlockValue('sub_headline', 'content', opBlocks[block], content)}
      </h4>

      <div
        className="text-xl space-y-2 border-t border-opacity-70	 border-gray-400 pt-4"
        style={{
          borderColor: returnBlockValue(
            'textcolor',
            'design',
            opBlocks[block],
            design
          ),
        }}
      >
        {returnBlockValue('todos', 'content', opBlocks[block], content).map(
          (todo, index) => (
            <TodoItem
              key={index}
              id={id}
              todo={todo}
              index={index}
              content={content}
            />
          )
        )}
      </div>
    </div>
  )
}

export default Block
